import { UserAuthForm } from '@r/components/auth/user-auth-form.tsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';
import defaultLogo from '@r/assets/images/fiddy/logo.svg';
import { Helmet } from 'react-helmet-async';
import { UseWorkspaceConfigs } from '@r/hooks/use-workspace-config.ts';

// import { Link } from '@tanstack/react-router';
// import { Button } from '@ui/button.tsx';

const AuthenticationPage = () => {
  const workspaceConfigContext = useContext(WorkspaceConfigContext);
  const { t } = useTranslation();
  const workspaceConfig = UseWorkspaceConfigs(true);
  const pageDescription =
    workspaceConfig.data?.groupedConfigs?.core?.description || t('app.description');

  return (
    <>
      <Helmet>
        <meta name="description" content={pageDescription} />
      </Helmet>
      <div className="container flex flex-col pt-8 grow">
        {/*<div className="flex justify-end mb-7 w-full sm:mb-0">*/}
        {/*  <Link to="/">*/}
        {/*    <Button variant="outline" className="mr-3">*/}
        {/*      À propos*/}
        {/*    </Button>*/}
        {/*  </Link>*/}

        {/*  <Link to="/">*/}
        {/*    <Button variant="outline">*/}
        {/*      Contact*/}
        {/*    </Button>*/}
        {/*  </Link>*/}
        {/*</div>*/}

        <div className="flex w-full max-w-[100%] flex-grow items-center sm:w-[32rem]">
          <Card className="w-[32rem] rounded-[30px] p-16">
            <CardHeader className="p-0 text-center">
              <img
                src={workspaceConfigContext?.groupedConfigs?.media?.logo || defaultLogo}
                className="object-contain object-center px-6 m-auto w-full xs:w-10/12 sm:w-8/12 md:w-7/12"
                alt="logo"
              />

              <CardTitle className="break-words text-center font-author-complete font-regular text-[2rem] leading-[3rem] sm:text-[2.3rem]">
                {t('auth.welcome', {
                  workspace: workspaceConfigContext?.groupedConfigs?.core?.title
                })}
              </CardTitle>

              <CardDescription className="text-sm font-light text-center text-muted-foreground">
                {t('auth.client.description', {
                  workspaceConfigName: workspaceConfigContext?.groupedConfigs?.core?.title
                })}
              </CardDescription>
            </CardHeader>

            <CardContent className="p-0 mt-12">
              <UserAuthForm showFirstLoginLink />
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AuthenticationPage;
